module.exports = __webpack_public_path__ + "static/media/address.c2a3d522.svg";